export default {
  init() {
    // JavaScript to be fired on all pages
    $('.sticky-search').hide();
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      var height = $('.header-pc').height();
      if (scroll >= height) {
        $('.sticky-search').show();
      } else {
        $('.sticky-search').hide();
      }
    });

    /* SEARCH */
    $(document).ready(function ($) { 
      $('.facetwp-date-min').attr('placeholder', 'Desde'); 
      $('.facetwp-date-max').attr('placeholder', 'Hasta');
    }); 

    // ModalSearch
    $('.search_modal_button').click(function () {
      $('.modalbusqueda').fadeIn();
      $('.modalbusqueda__closebtn').fadeIn();
    });

    $('.modalbusqueda__closebtn').click(function () {
      $('.modalbusqueda').fadeOut();
      $('.modalbusqueda').close();
    });


    //dropdown
    $(document).click(function (event) {
      var $target = $(event.target);
      if (!$target.closest('.nav-pc ul#menu-menu-top .menu-item-has-children ul.dropdown-menu').length &&
        $('.bg_menu').is(':visible')) {
        jQuery('.bg_menu').css('display', 'none');
      }
    });


    $('.nav-pc ul#menu-menu-top .menu-item-has-children ul.dropdown-menu a').click(function () {
      jQuery('.bg_menu').css('display', 'none');
    });

    $('.nav-pc ul#menu-menu-top .menu-item-has-children > a').click(function () {

      console.log('testing');
      if ($(this).parent().hasClass('show')) {
        console.log('cerrado');
        jQuery('.bg_menu').css('display', 'none');
      } else {
        console.log('abierto');
        setTimeout(function () {
          var altura_menu = jQuery('ul.dropdown-menu.show').height();
          altura_menu = parseInt(altura_menu) + 50;
          jQuery('.bg_menu').css('height', altura_menu + 'px');
          jQuery('.bg_menu').css('display', 'initial');
        }, 1);
      }

    });




  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js